import './_product-card.scss';
import component from './product-card';

export default component;
